import * as constants from '../constants/ActionTypes';

const initialState = {
  isChatModalOpen: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.LOAD_CHAT_INELIGIBLE_MODAL_CONTAINER :
      return Object.assign({}, state, { isChatModalOpen: true });
    case constants.CLOSE_CHAT_INELIGIBLE_MODAL_CONTAINER :
      return Object.assign({}, state, { isChatModalOpen: false });
    default:
      return state;
  }
}
